import React from 'react';
import { fetch_data } from './Data';
import {
   encode_query_params, parse_query_string,
} from './Utils';

type LoadDataProps = {
  dataset: string,
  type: string,
  component: any,
  n_shards: number,
  initial_data_id?: null | string,
};

type LoadDataState = {
  data: any | null,
  data_id: string | null,
};

export default class LoadDataComponent extends React.Component<LoadDataProps, LoadDataState> {
  constructor(props: LoadDataProps) {
    super(props);

    const d = parse_query_string();
    let data_id;
    if (d.dataset === props.dataset) {
      data_id = d.data_id;
    } else {
      data_id = this.props.initial_data_id || null;
    }
    this.state = {
      data: null,
      data_id: data_id,
    };
    this.updateQueryParams();
  }

  componentDidUpdate(prevProps: LoadDataProps) {
    if (this.props.dataset !== prevProps.dataset) {
      console.log('Data changed!');
      this.setState({ data: null, data_id: this.props.initial_data_id || null })
      this.update_data()
    }
    this.updateQueryParams();
  }

  updateState(update: any, cb?: any) {
    this.setState(update, cb);
    console.log('update', update);

    setImmediate(() => {
      this.updateQueryParams();
    });
  }

  updateQueryParams() {
    const d: any = { data_id: this.state.data_id, dataset: this.props.dataset }
    let hash = window.location.hash;
    if (hash[0] === "/") { hash = hash.substring(1); }
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + encode_query_params(d) + hash;
    console.log(newurl)
    window.history.pushState({ path: newurl }, '', newurl);
  }

  async update_data() {
    let orig_type = this.props.type;
    const data = (await fetch_data(this.props.type, this.props.dataset, this.props.n_shards, this.state.data_id)).results;
    if (this.props.type !== orig_type) {
      console.log('changed type')
      return;
    }
    this.updateState({
      data: data,
    });
  }

  async componentDidMount() {
    this.update_data()
  }

  render() {
    const SubComponent = this.props.component;

    console.log('data', this.state.data, this.state.data_id)
    if (this.state.data === null) {
      return 'Loading...';
    }
    return (
      <SubComponent
        data={this.state.data}
        dataset={this.props.dataset}
        set_id={(new_id: string) => {
          this.updateState({ data_id: new_id, data: null }, this.update_data)
        }}
        data_id={this.state.data_id}
      />
    );
  }
}
